
import Vue from "vue";
import MaterialIcons from "../common/material-icons.vue";

export default Vue.extend({
  name: "component-search-btn",
  components: { MaterialIcons },
  props: {
    isPollSearchBtn: Boolean,
    isPlaceListNoData: Boolean,
    pc: Boolean,
  },
  computed: {
    showPollBtn(): boolean {
      return this.isPollSearchBtn && !this.isPlaceListNoData;
    },
  },
  methods: {
    searchBtnClicked() {
      this.$emit("search-btn-clicked");
    },
    pollSearchBtnClicked() {
      this.$emit("poll-search-btn-clicked");
    },
  },
});
